import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRouter } from "next/router";
import { NextSeo } from "next-seo";
import React, { useEffect } from "react";
import { Container, Header } from "../components";
var Main = function() {
    var router = useRouter();
    useEffect(function() {
        router.replace("/mint");
    }, [
        router
    ]);
    return /*#__PURE__*/ _jsx("main", {
        className: "flex flex-col flex-1 items-center justify-center py-8"
    });
};
var Page = function() {
    return /*#__PURE__*/ _jsxs(Container, {
        children: [
            /*#__PURE__*/ _jsx(NextSeo, {
                title: "Mint"
            }),
            /*#__PURE__*/ _jsx(Header, {}),
            /*#__PURE__*/ _jsx(Main, {})
        ]
    });
};
export default Page;
